import React from "react";
import { browserHistory } from "react-router";
import { isLoggedIn } from "../components/Utils";

export default class Login extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.loginRequest(this.refs.email.value, this.refs.password.value);
  }

  componentWillMount() {
    if (isLoggedIn()) {
      browserHistory.push("/events");
    }
  }

  render() {
    var loginMessage = null;
    if (localStorage.loginToken !== undefined && localStorage.loginToken == "invalid") {
      loginMessage = <div className="alert alert-danger">De gegevens zijn onjuist</div>;
    }

    var passworLostLink = "/password-lost";

    return (
      <div>
        <div className="form form-signin">
          <p className="form-signin-heading">Je kunt hieronder inloggen met jouw e-mailadres en wachtwoord.</p>

          {loginMessage}

          <form onSubmit={(e) => this.handleSubmit(e)}>
            <label htmlFor="inputEmail" className="sr-only">
              E-mailadres
            </label>
            <input type="email" name="email" ref="email" className="form-control" placeholder="E-mailadres" required />
            <label htmlFor="inputPassword" className="sr-only">
              Wachtwoord
            </label>
            <input type="password" name="password" ref="password" className="form-control" placeholder="Wachtwoord" required />
            <button className="btn btn-lg btn-primary btn-block" type="submit">
              Inloggen
            </button>
            <div className="password-lost-link">
              <a href={passworLostLink}>Nog geen wachtwoord of wachtwoord vergeten?</a>
            </div>
            <div className="global-links text-center">versie {JSON.parse(COMMIT_HASH)}</div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/Login.js